/* Quick add on DecantGems cards (owner 16 Oct 2026: "easier maken om te adden aan cart op collecties, quick add of zo").
   One delegated submit listener for every form[data-dg-qa] (snippets/dg-quickadd.liquid: product cards and the
   bestseller cards in the Brands menu). POST /cart/add.js, the card photo flies to the header cart (assets/dg-fly.js),
   the header count follows through Horizon's cart:lines-update, the button reads "Added" for 1.5 s. A refusal (422:
   sold out, stock limit) is printed on the card. Without JavaScript the form posts to /cart/add as usual. */
import { flyToCart, notifyCart } from '@dg/fly';

const DONE_MS = 1500;
let T = null;
let live = null;

function texts() {
  if (T) return T;
  try { T = JSON.parse(document.getElementById('dg-qa-t').textContent); } catch (e) { T = {}; }
  return T;
}
function say(msg) {
  if (!msg) return;
  if (!live) {
    live = document.createElement('div');
    live.className = 'dg-vh';
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
  }
  live.textContent = '';
  setTimeout(() => { live.textContent = msg; }, 60);
}
function photo(form) {
  const host = form.closest('.dg-card, .dg-mbest__item');
  const img = host && host.querySelector('img');
  const src = img && (img.currentSrc || img.src);
  if (!src || /^data:/.test(src)) return null;
  return { src, rect: img.getBoundingClientRect() };
}
function addUrl() {
  const r = window.Theme && window.Theme.routes;
  return ((r && r.cart_add_url) || '/cart/add') + '.js';
}

// Bestseller photos in the Brands panel get their source on the first entry into the desktop menu (or at once
// when the pointer / focus is already there): WebKit would fetch loading=lazy images of the hidden panel at load.
function wakeMenuImages() {
  document.querySelectorAll('img[data-dg-src]').forEach((img) => {
    if (img.dataset.dgSrcset) img.srcset = img.dataset.dgSrcset;
    img.src = img.dataset.dgSrc;
    img.removeAttribute('data-dg-src');
  });
}
const menu = document.querySelector('header-menu');
if (menu) {
  if (menu.matches(':hover') || menu.contains(document.activeElement)) wakeMenuImages();
  else {
    menu.addEventListener('pointerenter', wakeMenuImages, { once: true });
    menu.addEventListener('focusin', wakeMenuImages, { once: true });
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-dg-qa')) return;
  event.preventDefault();
  if (form.dataset.busy) return;
  const t = texts();
  const btn = form.querySelector('.dg-qa__btn');
  const label = form.querySelector('.dg-qa__txt');
  const err = form.querySelector('.dg-qa__err');
  const idle = label ? label.textContent : '';
  const id = Number(form.elements.id && form.elements.id.value);
  const name = (form.querySelector('.dg-qa__btn .dg-vh:last-child') || {}).textContent || '';
  form.dataset.busy = '1';
  if (btn) btn.setAttribute('aria-busy', 'true');
  if (err) { err.hidden = true; err.textContent = ''; }

  const reset = () => {
    form.classList.remove('dg-qa--done');
    if (label) label.textContent = idle;
    delete form.dataset.busy;
  };

  fetch(addUrl(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
  })
    .then((r) => r.json().catch(() => ({})).then((data) => ({ ok: r.ok, status: r.status, data })))
    .then((res) => {
      if (btn) btn.removeAttribute('aria-busy');
      if (!res.ok) {
        const d = res.data || {};
        const msg = (typeof d.description === 'string' && d.description) || (typeof d.message === 'string' && res.status === 422 && d.message) || t.error;
        if (err) { err.textContent = res.status === 422 && !d.description ? (t.soldout || msg) : msg; err.hidden = false; }
        delete form.dataset.busy;
        return;
      }
      const landed = flyToCart(photo(form));
      form.classList.add('dg-qa--done');
      if (label) label.textContent = t.added || idle;
      say(t.added_status ? t.added_status.replace('%n', name.replace(/^:\s*/, '')) : t.added);
      setTimeout(reset, DONE_MS);
      return notifyCart('dg-quickadd', [{ merchandiseId: String(id), quantity: 1 }], landed)
        .then(() => { if (/\/cart\/?$/.test(location.pathname)) location.reload(); })
        .catch(() => {});
    })
    .catch(() => {
      if (btn) btn.removeAttribute('aria-busy');
      if (err) { err.textContent = t.error || ''; err.hidden = false; }
      delete form.dataset.busy;
    });
});
